import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import { formatValue } from "../../../utilities";
import { differentiate } from "../../../data/data";
import { withStyles } from "@material-ui/core";
import styleConstants from "../../../styleConstants";
import PanelChart from "../../chart/PanelChart";
import WaterfallChart from "../../chart/WaterfallChart";

const styles = {
  smallLineChart: {
    padding: "0 5px",
    border: "0px solid #eee"
  }
};

const getSeries = data =>
  methods.map(method => {
    let seriesData = data
      .filter(datum => datum.method === method)
      .map(datum => ({
        ...datum,
        year: parseInt(datum.year, 10)
      }))
      .sort((a, b) => a.year - b.year)
      .map(datum => ({ y: datum.value, users: datum.users }));

    const finalUsers = seriesData[seriesData.length - 1].users;

    seriesData = differentiate(seriesData);

    return {
      name: method,
      color: styleConstants.categoryColors.methodColors[method],
      data: [
        ...seriesData,
        {
          y: 0,
          isSum: true,
          users: finalUsers
        }
      ],
      pointPadding: 0.025
    };
  });

const formatTooltip = point => {
  const pointIndex = point.point.index;

  const method = point.series.name;
  const year = point.key;

  if (pointIndex === 0 || pointIndex === point.series.data.length - 1) {
    return `${method} Users, ${year}: <strong>${formatValue(
      point.point.users
    )}</strong><br />Share of Users, ${year}: <strong>${formatValue(
      point.y,
      true
    )}</strong>`;
  } else {
    const initialYear = 2020 + 5 * (pointIndex - 1);

    return `Change in ${method} Use, ${initialYear}-${initialYear +
      5}: <strong>${formatValue(
      point.point.users
    )}</strong><br />Percentage Point Change: <strong>${formatValue(
      point.y,
      true
    )}</strong>`;
  }
};

const ChangeInMethodMixChart = props => {
  const series = getSeries(props.data);

  const maximumValue = Math.max(
    ...series.flatMap(x => x.data.map(datum => datum.y))
  );

  return (
    <PanelChart>
      {methods.map((method, index) => (
        <WaterfallChart
          key={method}
          title={method}
          marginLeft={index === 0 ? 60 : 0}
          width={index === 0 ? 180 : 120}
          yAxis={{
            minimum: 0,
            maximum: maximumValue,
            showLabels: index === 0
          }}
          series={[series[index]]}
          tooltipFormatter={function() {
            return formatTooltip(this);
          }}
          className={props.classes.smallLineChart}
          onRegisterChartRef={ref => {
            props.onRegisterChartRef(index, ref);
          }}
        />
      ))}
    </PanelChart>
  );
};

ChangeInMethodMixChart.propTypes = {
  data: PropTypes.array.isRequired,
  onRegisterChartRef: PropTypes.func.isRequired
};

export default memo(withStyles(styles)(ChangeInMethodMixChart));
